import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WCmsPageSummaryView } from '@zola/svc-web-api-ts-client';
import { AppThunk } from '../reducers';
import * as ActionTypeValues from './types/WeddingWebsiteActionTypes';
import type { SetPageSummariesActionType } from './types/WeddingWebsiteActionTypes';

const setPageSummaries = (
  payload: Record<string, WCmsPageSummaryView>
): SetPageSummariesActionType => ({
  type: ActionTypeValues.SET_PAGE_SUMMARIES,
  payload,
});

export const fetchPageSummaries =
  (pageIds: string[]): AppThunk<void> =>
  (dispatch) => {
    const query = pageIds.map((id) => `pageId=${id}`).join('&');

    return ApiService.get(`/website-nav/web-api/v1/cms/getPageSummaries?${query}`).then((json) => {
      if (!Array.isArray(json)) return {};

      const summariesByPageId: Record<string, WCmsPageSummaryView> = json.reduce((acc, summary) => {
        acc[summary.type] = summary;
        return acc;
      }, {});

      dispatch(setPageSummaries(summariesByPageId));
      return summariesByPageId;
    });
  };
